import Phone from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useState } from "react";
import { AppText } from "../../../utils";
import { ErrorText } from "../../Component";

export const PhoneInput = ({
  label = "Phone Number",
  phone,
  countryCode,
  required,
  baseClass,
  labelGroupClass,
  labelClass,
  onError = () => {},
  onChange = () => {},
}) => {
  const [error, setError] = useState(null);

  const isValidateInput = (phoneNumber) => {
    let valueLength = phoneNumber.length;

    if (valueLength > 0) {
      let minLength = 7;
      let maxLength = 15;
      let IsError = valueLength < minLength || valueLength > maxLength;
      if (!IsError) {
        IsError = !/^\d+$/.test(phoneNumber);
      }
      onError(IsError);
      setError(IsError ? AppText.invalidPhone : null);
    } else {
      onError(false);
      setError(null);
    }
  };

  return (
    <div className={"form-group" + (baseClass ? baseClass : "")}>
      <div className={"form-label-group " + (labelGroupClass ? labelGroupClass : "")}>
        <label className={"form-label " + (labelClass ? labelClass : "")} htmlFor={label?.toLowerCase()}>
          {label} {required && <span className="text-danger fs-6">*</span>}
        </label>
      </div>
      <div className="form-control-wrap">
        <Phone
          countryCodeEditable={false}
          country={"gb"}
          value={(countryCode ?? "") + (phone ?? "")}
          onChange={(value, data, event, formattedValue) => {
            event.preventDefault();
            let phoneNumber = value.slice(data.dialCode.length, value.length);
            let dialCode = data.dialCode;
            onChange({
              phoneNumber: phoneNumber,
              dialCode: dialCode,
              formattedValue: formattedValue,
            });
            // Validate when phone number changes
            if (phoneNumber.length > 0) {
              isValidateInput(phoneNumber);
            } else {
              // Clear error when phone number is empty
              onError(false);
              setError(null);
            }
          }}
          inputClass="w-100"
          onBlur={() => {
            // Use the current phone prop value for validation
            if (phone) {
              isValidateInput(phone);
            }
          }}
        />
        {error && <ErrorText>{error}</ErrorText>}
      </div>
    </div>
  );
};
